module.exports = dormakaba.vendorReact['vendor/react-dom'];